import type { InboxItem } from "./types";

const NO_CAMPAIGN_GROUP = "__none__";

export type InboxListRow =
  | {
      kind: "conversation";
      key: string;
      item: InboxItem;
    }
  | {
      kind: "campaign";
      key: string;
      groupId: string;
      name: string;
      count: number;
      collapsed: boolean;
    };

export function buildInboxListRows(
  items: InboxItem[],
  groupByCampaign: boolean,
  collapsedGroups: Set<string>,
): InboxListRow[] {
  if (!groupByCampaign) {
    return items.map((item) => ({
      kind: "conversation",
      key: `conversation:${item._id}`,
      item,
    }));
  }

  const order: string[] = [];
  const groups = new Map<
    string,
    { id: string; name: string; items: InboxItem[] }
  >();
  for (const item of items) {
    const campaign = item.campaigns[0];
    const id = campaign?._id || NO_CAMPAIGN_GROUP;
    let group = groups.get(id);
    if (!group) {
      group = { id, name: campaign?.name || "No campaign", items: [] };
      groups.set(id, group);
      order.push(id);
    }
    group.items.push(item);
  }

  const rows: InboxListRow[] = [];
  for (const id of order) {
    const group = groups.get(id)!;
    const collapsed = collapsedGroups.has(id);
    rows.push({
      kind: "campaign",
      key: `campaign:${id}`,
      groupId: id,
      name: group.name,
      count: group.items.length,
      collapsed,
    });
    if (!collapsed) {
      rows.push(
        ...group.items.map((item) => ({
          kind: "conversation" as const,
          key: `conversation:${item._id}`,
          item,
        })),
      );
    }
  }
  return rows;
}
